import React, { useEffect, useState, useCallback } from 'react';
import Config from '../../config/Config';
import PaytmPost from './paytmPost';
import Loader from '../../utils/Loader';
import $ from 'jquery';
import YouTube from 'react-youtube';
import LoadingPaymentModel from '../common/loadingPaymentModel';
import { appendScript } from '../../utils/appendScript';
import { connect } from 'react-redux';
import {
	validateCoupon,
	startTransaction,
	onCouponChange,
	resetChecksum,
	updateApiCount,
	setShowPreviewCourses,
} from '../../redux/buyCourse/buyCourse.actions';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import './purchase.css';
import Carousel from 'react-bootstrap/Carousel';
import { tagEvent } from '../../utils/tagManager';
import Alert from 'react-bootstrap/Alert';

const opts = {
	playerVars: {
		autoplay: 0,
		controls: 1,
		disablekb: 1,
		fs: 0,
		showinfo: 0,
		loop: 1,
		modestbranding: 1,
		rel: 0,
		maxWidth: '50% !important',
		width: '300px',
		height: '300px',
	},
};

const ProductDetail = ({
	productData,
	discountPrice,
	error: { panelClass, panelMsg },
	productData: {
		product_icon_url: productIconUrl,
		product_video_url: productVideoUrl,
		product_tag_line: productTagLine,
		product_description: productDescription,
		offer_price,
		original_price,
		preview_details,
		grants,
		product_id,
		product_name,
	},
	couponCode,
	apiCount,
	discountedPrice,
	validateCoupon,
	onCouponChange,
	updateApiCount,
	startTransaction,
	setErrorPanel,
	setShowPreviewCourses,
	userId,
	platform,
	isRetail,
	currentProductId,
}) => {
	const [productOriginalPrice, setProductOriginalPrice] = useState(0);
	const [OfferPercent, setOfferPercent] = useState(0);
	const [productOfferPrice, setproductOfferPrice] = useState(0);
	const [OrginalPriceSpan, setOrginalPriceSpan] = useState('');
	const [OfferPercentSpan, setOfferPercentSpan] = useState('');
	const [couponCodeText, setcouponCodeText] = useState('');

	const handleTransaction = useCallback(() => {
		if (localStorage.getItem('TriggerBuyNow') !== 'Yes') {
			Loader.show();
		}

		let couponCodeTrim = couponCode.replace(/\s/g, '');
		if (couponCodeTrim !== '') {
			validateCoupon(couponCodeTrim);
		} else {
			startTransaction();
		}
	}, [couponCode, startTransaction, validateCoupon]);

	const handleKeyDown = (event) => {
		if (event.keyCode === 13) {
			handleCoupon();
			event.preventDefault();
		}
	};
	const handleCoupon = () => {
		let couponCodeTrim = couponCode.replace(/\s/g, '');
		if (!!couponCodeTrim) {
			setErrorPanel({});
			Loader.show();
			validateCoupon(couponCodeTrim, 'getprice');
		} else {
			setErrorPanel({
				panelMsg: 'Please enter a coupon code.',
				panelClass: 'alert alert-danger',
			});
			document.body.scrollTo(0, 0);
		}
	};

	useEffect(() => {
		if (!!product_id && product_id === currentProductId) {
			tagEvent({
				event: 'webclient_product_view',
				user_id: userId,
				product_id,
				product_name,
				device: 'web',
			});
		}
	}, [currentProductId, product_id, product_name, userId]);

	useEffect(() => {
		if (localStorage.getItem('TriggerBuyNow') === 'Yes') {
			$('.download-app').hide();
			$('.body-container').css('background', '#e5f3fa');
		} else {
			localStorage.removeItem('CouponCode');
		}
		if (
			typeof productData !== 'undefined' &&
			localStorage.getItem('TriggerBuyNow') === 'Yes' &&
			apiCount === 0
		) {
			//delay added to trigger product details first
			updateApiCount(1);
			Loader.show();
			setTimeout(() => {
				handleTransaction();
				localStorage.removeItem('TriggerBuyNow');
			}, 3000);
		}
	}, [apiCount, handleTransaction, productData, setErrorPanel, updateApiCount]);

	useEffect(() => {
		setErrorPanel({});
		appendScript('exit-popup');
		document.body.addEventListener('scroll', () => {
			var scroll = document.body.scrollTop;
			if (scroll > 430) {
				$('body').addClass('payment-bottom-show');
				$('.product-payment-block.pro-pay-bottom').addClass('comeUpNow');
			} else {
				$('body').removeClass('payment-bottom-show');
				$('.product-payment-block.pro-pay-bottom').removeClass('comeUpNow');
			}
		});
	}, [setErrorPanel]);

	useEffect(() => {
		setproductOfferPrice(offer_price);
	}, [offer_price]);

	useEffect(() => {
		setProductOriginalPrice(original_price);
	}, [original_price]);
	useEffect(() => {
		if (!!discountPrice) {
			setproductOfferPrice(Math.round(discountedPrice));
			setcouponCodeText(
				<span className="product-detail-success">
					<img
						src={Config.ASSETSPATH + 'img/couponsuccess.png'}
						alt="coupon success"
					/>
					Great! You just saved ₹{productOriginalPrice - discountedPrice}
				</span>,
			);
		}
	}, [discountPrice, discountedPrice, productOriginalPrice]);

	useEffect(() => {
		if (typeof productData !== 'undefined') {
			setOfferPercent(
				Math.round(
					((productOriginalPrice - productOfferPrice) / productOriginalPrice) * 100,
				),
			);
		}
	}, [productOriginalPrice, productData, productOfferPrice]);

	useEffect(() => {
		if (productOriginalPrice !== productOfferPrice) {
			setOrginalPriceSpan(
				<div className="product-price-original">₹ {productOriginalPrice} </div>,
			);
			setOfferPercentSpan(<div className="ribbon"> {OfferPercent}% off</div>);
		} else {
			setOrginalPriceSpan('');
			setOfferPercentSpan('');
		}
	}, [productOriginalPrice, productOfferPrice, OfferPercent]);

	return (
		<div>
			{localStorage.getItem('TriggerBuyNow') === 'Yes' ? (
				<div style={{ marginTop: '100px' }}>
					<LoadingPaymentModel />
				</div>
			) : (
				<div className="bg-white mar-all">
					<div className={panelClass}>{panelMsg}</div>
					<div className="pad-all">
						<p
							className="alert alert-danger"
							id="ErrorProduct"
							style={{ display: 'none' }}
						>
							Please select the State
						</p>
						<div className="display-flex align-center mar-hoz">
							<div className="width-50">
								{!!productVideoUrl ? (
									<YouTube
										className="product-detail-video-block"
										videoId={productVideoUrl}
										currentTime={new Date().getTime()}
										opts={opts}
									/>
								) : (
									<img
										src={productIconUrl}
										alt="olympiad"
										className="img-responsive product-detail-logo-block"
									/>
								)}
								{<p className="product-tagline">{productTagLine}</p>}
							</div>

							<div className="width-50">
								<div className=" product-payment-block">
									{OfferPercentSpan}
									<div className="col-lg-12">
										<div className="product-price-block">
											<div className="product-detail-price">
												{OrginalPriceSpan}
												<div className="product-price-offers">
													<span style={{ fontSize: '22px', fontWeight: 400 }}>₹</span>
													{productOfferPrice}
												</div>
											</div>
											<span className="product-detail-tax">Price is inclusive of GST</span>
											{couponCodeText}
										</div>
									</div>
									<div className="col-lg-12 product-detail-padding">
										<form className="form-inline">
											<div className="form-coupon">
												<div className="input-group">
													<input
														type="text"
														className="form-control"
														id="couponCode"
														name="couponCode"
														value={couponCode}
														onChange={onCouponChange}
														placeholder="Have a Coupon?"
														onKeyDown={handleKeyDown}
														autoComplete="off"
													/>
													<span className="input-group-btn">
														<button
															aria-label="apply-coupon"
															className="paper-plane"
															type="button"
															onClick={handleCoupon}
														>
															<img src={Config.ASSETSPATH + 'img/apply-button.png'} alt="" />
														</button>
													</span>
												</div>
											</div>
										</form>
									</div>
									<span className="display-flex justify-content-between">
										<div className="get-free-button" onClick={handleTransaction}>
											Buy Now
										</div>
									</span>
									<small className="byclick">
										Clicking on the BUY NOW button will take you to the secure PayTM site
										where you can complete the payment.
									</small>
								</div>
							</div>
						</div>
						{!!isRetail && !!preview_details && preview_details.length > 0 && (
							<div className="product-description-list">
								{product_id == 638 ? (
								<Alert variant="info">
									While previewing the IELTS course, you will be able to see all the units (the syllabus), and you will be able to access the introductory module.
								</Alert>
							): (
								<Alert variant="info">
									While previewing a course, you will be able to see all the units (the
									syllabus), and you will be able to access the first three course
									modules.
								</Alert>
							)}


								<Carousel>
									{preview_details?.map((course) => {
										const { course_title, course_description, course_id } = course;

										return (
											<Carousel.Item>
												<div key={course_id} className="daily-step-widget dash-courses">
													<div className="dash-course-logo">
														<img
															src={Config.STORAGEPATH + 'img/courses/' + course_id + '.png'}
															alt="courseimage"
														/>
													</div>
													<div className="dash-course-decs">
														<p>{course_title}</p>
														<p className="dash-decs-date">
															<strong>{course_description}</strong>
														</p>
														<a
															onClick={() =>
																tagEvent({
																	event: 'preview_course',
																	user_id: userId,
																	course_id,
																	grant_name: grants,
																	product_id,
																	product_name,
																	platform: 'web',
																})
															}
															href={`/mycourse?course_id=${course_id}&previewMode=1`}
															className="dash-course-decs-bottom"
														>
															<button className="btn btn-primary">Preview Course</button>
														</a>
													</div>
												</div>
											</Carousel.Item>
										);
									})}
								</Carousel>
							</div>
						)}
						<div className="product-description-list">
							<div
								className="product-description-list"
								dangerouslySetInnerHTML={{ __html: productDescription }}
							/>
						</div>
						<div className="product-payment-block pro-pay-bottom">
							<div className="product-payment-container">
								{OfferPercentSpan}
								<div className=" product-price-container">
									<div className="product-price-block">
										<div className="product-detail-price">
											{OrginalPriceSpan}

											<div className="product-price-offers">
												<span style={{ fontSize: '22px', fontWeight: '400' }}>₹</span>
												{productOfferPrice}
											</div>
										</div>
									</div>
									<span className="product-detail-tax">Price is inclusive of GST</span>
								</div>
								<div style={{ alignSelf: 'center', paddingTop: '15px' }}>
									<div className=" product-detail-padding">
										<form className="form-inline">
											<div className="form-coupon">
												<div className="input-group">
													<input
														type="text"
														className="form-control"
														id="couponCode"
														name="couponCode"
														value={couponCode}
														onChange={onCouponChange}
														placeholder="Have a Coupon?"
														onKeyDown={handleKeyDown}
														autoComplete="off"
													/>
													<span className="input-group-btn">
														<button
															className="paper-plane"
															type="button"
															onClick={handleCoupon}
														>
															<img src={Config.ASSETSPATH + 'img/apply-button.png'} alt="" />
														</button>
													</span>
												</div>
											</div>
										</form>
									</div>

									{couponCodeText}
									<div className="display-flex justify-content-between get-free-container">
										<div className="get-free-button" onClick={handleTransaction}>
											Buy Now
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<PaytmPost />
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		productId,
		productData,
		couponCode,
		apiCount,
		discountedPrice,
		navbarHide,
		discountPrice,
		currentProductId,
	} = state.rootReducer.buyCourse;
	const { userId, isRetail } = state.rootReducer.loginDetails;
	return {
		productId,
		productData,
		couponCode,
		apiCount,
		discountedPrice,
		navbarHide,
		discountPrice,
		error: state.rootReducer.utils.errorPanel,
		userId,
		isRetail,
		currentProductId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		validateCoupon: (couponCode, price) =>
			dispatch(validateCoupon(couponCode, price)),
		onCouponChange: (event) => dispatch(onCouponChange(event.target.value)),
		startTransaction: () => dispatch(startTransaction()),
		updateApiCount: (id) => dispatch(updateApiCount(id)),
		resetChecksum: () => dispatch(resetChecksum()),
		setShowPreviewCourses: (val) => dispatch(setShowPreviewCourses(val)),
		setErrorPanel: (msg) => dispatch(setErrorPanel(msg)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
